export const conveyanceNameMaxLength = 50;
export const containerDescriptionMaxLength = 100;
